"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressLabel = exports.ProgressForeground = exports.ProgressBackground = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var barHeight = 6;
exports.ProgressBackground = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var colors = _a.theme.colors;
    return "\n    width: 100%;\n    background: ".concat(colors.borderMuted, ";\n    height: ").concat(barHeight, "px;\n    position: relative;\n    border-radius: ").concat(barHeight / 2, "px;\n    margin-top: 8px;\n");
});
exports.ProgressForeground = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width, colors = _a.theme.colors;
    return "\n    background: ".concat(colors.primary, ";\n    height: ").concat(barHeight, "px;\n    position: absolute;\n    border-radius: ").concat(barHeight / 2, "px;\n    left: 0;\n    top: 0;\n    width: ").concat(width, "%;\n    max-width: 100%;\n  ");
});
exports.ProgressLabel = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  display: flex;\n  align-items: flex-start;\n  margin-top: 16px;\n  margin-bottom: 8px;\n\n  > * {\n    margin-right: 8px;\n  }\n"], ["\n  color: ", ";\n  display: flex;\n  align-items: flex-start;\n  margin-top: 16px;\n  margin-bottom: 8px;\n\n  > * {\n    margin-right: 8px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.text.color;
});
var templateObject_1, templateObject_2, templateObject_3;
